import React, { useState } from "react";
import moment from "moment";
import "./AccordionPatrolSp.css";

const VALID_TYPES = ["print", "pasang sticker", "punching", "patrol"];

const Sep = () => <span className="aps_sep">|</span>;

const AccordionPatrolSp = ({ data }) => {
  const [openId, setOpenId] = useState(null);

  const toggleAccordion = (id) => {
    setOpenId(openId === id ? null : id);
  };

  const items = (data || []).filter((item) => VALID_TYPES.includes(item.type));

  if (items.length === 0) {
    return (
      <div className="aps_list">
        <p className="aps_empty">Belum ada data</p>
      </div>
    );
  }

  return (
    <div className="aps_list">
      {items.map((item) => {
        const id = item._id?.$oid || item._id || item.id;
        const isOpen = openId === id;

        // ===== VALIDASI =====
        const hasPunchingTrouble = item.checklistPunching?.some(
          (c) => c.isTrouble
        );

        const hasPatrolTrouble =
          item.type === "patrol" &&
          item.kindOfReject?.some((r) => Number(r.reject) > 0);

        const totalReject = item.kindOfReject?.reduce(
          (sum, r) => sum + Number(r.reject || 0),
          0
        );

        const headerClass = [
          "aps_header",
          hasPatrolTrouble ? "is_danger" : "",
          hasPunchingTrouble ? "is_warning" : "",
        ]
          .filter(Boolean)
          .join(" ");

        const isPrintLike =
          item.type === "print" || item.type === "pasang sticker";
        const isPunchOrPatrol =
          item.type === "punching" || item.type === "patrol";

        const inputUser = item.inputUser || {};
        const hasInputUser =
          inputUser.bawah !== undefined ||
          inputUser.atas !== undefined ||
          inputUser.kanan !== undefined ||
          inputUser.kiri !== undefined;

        return (
          <div className="aps_item" key={id}>
            {/* ===== HEADER ===== */}
            <button
              type="button"
              className={headerClass}
              aria-expanded={isOpen}
              onClick={() => toggleAccordion(id)}
            >
              <span className="aps_title">
                {hasPatrolTrouble && <span className="aps_alert">🚨</span>}

                {isPrintLike && (
                  <>
                    <span className="aps_va">VA</span>
                    <Sep />
                    <span>{item.type.toUpperCase()}</span>
                    <Sep />
                    <span>{item.dokumen}</span>
                    <Sep />
                    <span>{item.screen}</span>
                  </>
                )}

                {isPunchOrPatrol && (
                  <>
                    {item.type === "punching" && (
                      <>
                        <span className="aps_va">VA</span>
                        <Sep />
                      </>
                    )}
                    <span>{item.type.toUpperCase()}</span>
                    <Sep />
                    <span>{item.mesin?.toUpperCase()}</span>
                    {item.jenisPatrol !== "pasang sticker" && (
                      <>
                        <Sep />
                        <span>{item.produk}</span>
                      </>
                    )}
                    {item.type === "patrol" && (
                      <>
                        <Sep />
                        <span>{item.jenisPatrol?.toUpperCase()}</span>
                      </>
                    )}
                  </>
                )}
              </span>

              <span
                className={`aps_chevron ${isOpen ? "is_open" : ""}`}
                aria-hidden="true"
              />
            </button>

            {/* ===== CONTENT ===== */}
            <div className={`aps_body ${isOpen ? "is_open" : ""}`}>
              <div className="aps_body_inner">
                <div className="aps_content">
                  <div className="aps_meta">
                    <span className="aps_meta_label">Petugas</span>
                    <span>{item.petugas}</span>
                    <span className="aps_meta_label">Time</span>
                    <span>
                      {moment(item.timestamp)
                        .utcOffset(7)
                        .format("DD-MM-YYYY, HH:mm:ss")}
                    </span>
                    {isPrintLike && item.screen && (
                      <>
                        <span className="aps_meta_label">Screen</span>
                        <span>{item.screen}</span>
                      </>
                    )}
                  </div>

                  {/* ===== PRINT / STICKER ===== */}
                  {isPrintLike && hasInputUser && (
                    <>
                      <br />
                      <p className="aps_section">Input user</p>
                      <div className="aps_chips">
                        {inputUser.atas !== undefined && (
                          <span className="aps_chip">
                            <b>Atas</b> {inputUser.atas} mm
                          </span>
                        )}
                        {inputUser.bawah !== undefined && (
                          <span className="aps_chip">
                            <b>Bawah</b> {inputUser.bawah} mm
                          </span>
                        )}
                        {inputUser.kiri !== undefined && (
                          <span className="aps_chip">
                            <b>Kiri</b> {inputUser.kiri} mm
                          </span>
                        )}
                        {inputUser.kanan !== undefined && (
                          <span className="aps_chip">
                            <b>Kanan</b> {inputUser.kanan} mm
                          </span>
                        )}
                      </div>
                    </>
                  )}

                  {/* ===== PUNCHING ===== */}
                  {item.type === "punching" && (
                    <>
                      <br />
                      <p className="aps_section">Checklist</p>
                      <ul className="aps_check_list">
                        {item.checklistPunching?.map((c, i) => (
                          <li
                            key={i}
                            className={c.isTrouble ? "is_trouble" : ""}
                          >
                            <span>{c.id}</span>
                            <span>
                              {c.isChecked ? "✅" : "❌"} {c.isTrouble && "⚠️"}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}

                  {/* ===== PATROL ===== */}
                  {item.type === "patrol" && (
                    <>
                      <div className="aps_stats">
                        <div className="aps_stat">
                          <span className="aps_stat_label">
                            Jumlah sampling
                          </span>
                          <span className="aps_stat_value">
                            {item.jumlahSampling} Pcs
                          </span>
                        </div>
                        <div
                          className={`aps_stat ${
                            hasPatrolTrouble ? "is_danger" : ""
                          }`}
                        >
                          <span className="aps_stat_label">Total reject</span>
                          <span className="aps_stat_value">
                            {totalReject} Pcs
                          </span>
                        </div>
                      </div>
                      <br />
                      <p className="aps_section">Data reject</p>
                      <div className="aps_table_wrap">
                        <table className="aps_table">
                          <thead>
                            <tr>
                              <th>Tanggal</th>
                              <th>Reject</th>
                              <th className="aps_num">Qty</th>
                              <th>Bagian</th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.kindOfReject?.map((r, i) => (
                              <tr key={i}>
                                <td className="aps_nowrap">{r.dateReject}</td>
                                <td>{r.id}</td>
                                <td className="aps_num">{r.reject}</td>
                                <td>{r.bagian}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AccordionPatrolSp;
